import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import SupplierHistoryService from "../../Controller/SupplierHistoryController";
import CreateSupplierHistory from "./CreateSupplierHistory";
import SupplierContactService from "../../Controller/SupplierContactController";
import HelpSite from "../../../Common/HelpLink";
function SupplierHistoryPage({ SupplierID, isLock, Phone, IsDiaries, CommunicationID, CompanyName, ToEmail,Tab }) {
    SupplierID = localStorage.getItem('SupplierID');
    const navigate = useNavigate();
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    const [SupplierContactList, setSupplierContacts] = useState([]);
    const [SupplierHistoryList, setSupplierHistory] = useState([]);
    const [modalInstance, setModalInstance] = useState(null);
    const [currentSupplierHistory, setCurrentSupplierHistory] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };
    const fetchSupplierHistory = async () => {
        try {
            let data = await SupplierHistoryService.GetAllSupplierHistory(redirectCallback, SupplierID);
            setSupplierHistory(data);
            if (IsDiaries === "1" && CommunicationID > 0) {

                data = data.filter(a => a.PK_SupplierHistoryID === CommunicationID);
                handleEditClick(data[0]);
            }
        } catch (error) {
            console.error('Error fetching Contacts:', error);
        }
    };
    const fetchSupplierContact = async () => {
        try {
            const data = await SupplierContactService.GetAllSupplierContacts(redirectCallback, SupplierID);
            setSupplierContacts(data);
        } catch (error) {
            console.error('Error fetching Contacts:', error);
        }
    };
    useEffect(() => {
        if (SupplierID > 0) {
            fetchSupplierHistory();
            fetchSupplierContact();
        }
        else {
            setSupplierHistory([]);
            setSupplierContacts([]);
        }
    }, [SupplierID,Tab]);
    const handleCreateSupplierHistoryClick = () => {
        setCurrentSupplierHistory(null);
        fetchSupplierContact();
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleEditClick = (history) => {
        setCurrentSupplierHistory(history);
        fetchSupplierContact();
        setIsModalOpen(true);
    };

    const handleDeleteClick = async (ID, redirectCallback) => {
        const confirmed = window.confirm("Are you sure you want to delete this contact?");
        if (confirmed) {
            try {
                await SupplierHistoryService.DeleteSupplierHistory(redirectCallback, ID);
                fetchSupplierHistory(); // Refresh the list after deletion
            } catch (error) {
                console.error('Error deleting Contact:', error);
            }
        }
    };
    const handleSuccess = () => {
        fetchSupplierHistory(); // Refresh the list after submission
        handleCloseModal();   // Close the modal
    };
    const truncateText = (text, maxLength = 150) => {
        if (!text) return '';  // Return empty string if text is null or empty
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    };
    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>
            <div className="row mb-3" style={{marginLeft:"-5px"}}>
                <div className="col-sm-3">
                    <button className={`btn btn-primary btn-sm ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} onClick={handleCreateSupplierHistoryClick}>
                        <i className="icofont-plus" aria-hidden="true"> Add New</i>
                    </button>
                </div>
                <div className="col-sm-9" style={{ "textAlign": "right" }}>

                </div>
            </div>
            <div className="row mb-3" style={{marginLeft:"-5px"}}>
                <div className="col-sm-12">
                    <div className="">
                        <table className="table m-0 table-hover">
                            <thead>
                                <tr>
                                    <th className="no-wrap" style={{ "width": "10%" }}>Created</th>
                                    <th className="no-wrap" style={{ "width": "10%" }}>Type</th>
                                    <th className="no-wrap" style={{ "width": "15%" }}>Contact</th>
                                    <th className="no-wrap" style={{ "width": "25%" }}>Description</th>

                                    <th className="no-wrap" style={{ "width": "10%" }}>Due Date</th>
                                    <th className="no-wrap" style={{ "width": "10%" }}>Assigned To</th>
                                    <th className="no-wrap" style={{ "width": "15%" }}>Action By</th>
                                    <th className="no-wrap" style={{ "textAlign": "right" }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {SupplierHistoryList.map((history) => (
                                    <tr key={history.PK_SupplierHistoryID} onClick={localStorage.getItem('LicenseExpired') == "0" ? () => handleEditClick(history) : undefined}>
                                        <td className="no-wrap" style={{ "width": "10%" }}>{formatDate(history.dt_Created)}</td>
                                        <td className="no-wrap" style={{ width: "10%" }}>
                                            {(() => {
                                                switch (history.snt_CommunicationType.toString()) {
                                                    case "0":
                                                        return "Notes";
                                                    case "1":
                                                        return "Email";
                                                    case "2":
                                                        return "Task";
                                                    case "3":
                                                        return "Appointment";
                                                    default:
                                                        return "Notes";
                                                }
                                            })()}
                                        </td>
                                        <td className="no-wrap" style={{ width: "15%" }}>{history.SuppName}</td>
                                        <td style={{ "width": "25%" }} dangerouslySetInnerHTML={{ __html: truncateText(history.vc_Description) }}></td>
                                        <td className="no-wrap" style={{ "width": "10%" }}>
                                            {(() => {
                                                switch (history.snt_CommunicationType.toString()) {
                                                    case "0":
                                                        return "";
                                                    case "1":
                                                        return "";
                                                    case "2":
                                                        return history.DueDate ? formatDate(history.DueDate) : ""
                                                    case "3":
                                                        return history.AppointmentDate ? formatDate(history.AppointmentDate) : ""
                                                    default:
                                                        return "";
                                                }
                                            })()}
                                        </td>
                                        <td className="no-wrap" style={{ "width": "10%" }}>{history.UserTask}</td>
                                        <td className="no-wrap" style={{ width: "15%" }}>{history.DisplayName}</td>
                                        <td className={`rightColumn ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} style={{ "textAlign": "right" }}>

                                            <button style={{ "background": "none", "border": "none" }} className="text-danger" onClick={() => handleDeleteClick(history.PK_SupplierHistoryID)}>
                                                <i className="icofont-ui-delete" aria-hidden="true"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            {isModalOpen && (
                <CreateSupplierHistory
                    modalInstance={modalInstance}
                    currentSupplierHistory={currentSupplierHistory}
                    onClose={handleCloseModal}
                    onSuccess={handleSuccess}
                    SupplierContactList={SupplierContactList}
                    SupplierID={SupplierID}
                    Phone={Phone}
                    CompanyName={CompanyName}
                    IsDiaries={IsDiaries}
                    ToEmail={ToEmail}

                />
            )}
        </div>
    );
}

export default SupplierHistoryPage;
